import { LanguagesConstants } from '../constants';

export function languages(state = {}, action) {
  switch (action.type) {
    case LanguagesConstants.GET_LANGUAGES_SUCCESS:
      return {
        ...state,
        languages:action.data
      };
    case LanguagesConstants.GET_LANGUAGES_FAILURE:
      return {
          ...state,
          languages:''
      };
    case LanguagesConstants.GET_LANGUAGES_REQUEST:
      return {};
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/store/reducers/languages.reducer.js